import { useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { SetFooterVisible } from "../../layout/SideBarLayout";
import { V3Button } from "../Button";
import { V3ButtonColor } from "../Button/V3Button.types";
import { VerticalSpacing } from "../VerticalSpacing";
import { IPFWrapper } from "./InfinitePaginationFooter.styles";

export const MAX_PAGES_LOADED = 2;

interface InfinitePaginationFooterProps {
    contentLoading: boolean;
    contentCanFetchmore: boolean;
    numPagesLoaded: number;
    loadMore: () => void;
    skipFooterControl?: boolean;
    scrollRoot?: Element | null;
}

export const InfinitePaginationFooter = ({
    contentLoading,
    numPagesLoaded,
    contentCanFetchmore,
    loadMore,
    skipFooterControl = false,
    scrollRoot
}: InfinitePaginationFooterProps) => {
    const setFooterVisible = useContext(SetFooterVisible);
    const [trackPageLoad, setTrackPageLoad] = useState(false);

    const IDLE_ABLE_TO_FETCH = !contentLoading && contentCanFetchmore;

    const { ref, inView } = useInView({
        threshold: 0,
        rootMargin: "0px 0px 400px",
        initialInView: false,
        root: scrollRoot
    });

    if (inView && IDLE_ABLE_TO_FETCH && trackPageLoad) {
        loadMore();
    }

    useEffect(() => {
        setTimeout(() => {
            setTrackPageLoad(true);
        }, 500);
    }, []);

    const canShowLoadMoreButton = numPagesLoaded > MAX_PAGES_LOADED;

    useEffect(() => {
        if (skipFooterControl) return;

        if (canShowLoadMoreButton || !contentCanFetchmore) {
            setFooterVisible(true);
        } else {
            setFooterVisible(false);
        }
    }, [canShowLoadMoreButton, contentCanFetchmore]);

    return (
        <>
            {!contentLoading && IDLE_ABLE_TO_FETCH && canShowLoadMoreButton && (
                <VerticalSpacing top={20}>
                    <IPFWrapper>
                        <V3Button text="Load more" onClick={loadMore} color={V3ButtonColor.secondary} autoWidth minWidth={150} />
                    </IPFWrapper>
                </VerticalSpacing>
            )}
            {IDLE_ABLE_TO_FETCH && !canShowLoadMoreButton && <div ref={ref} />}
        </>
    );
};
